import React from 'react'

type Props = {}

const Permissions = (props: Props) => {
  return (
    <div>Permissions</div>
  )
}

export default Permissions